import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";

interface Parameter {
    uuid: string;
}

type HandlerType = Handler<Parameter>;

export const RequestSyncAndNotify: HandlerType = async props => {
    try {
        await post("/api/v1/vertex/exemptioncertificates/sync-and-notify", { uuid: props.parameter.uuid });
    } catch (error) {
        // Fire-and-forget: a failure here must not disrupt the wizard. The scheduled Sync and
        // notification jobs remain the backstop, so we just log and move on.
        // eslint-disable-next-line no-console
        console.error("Failed to trigger certificate sync and notification:", error);
    }
};

export const chain = [RequestSyncAndNotify];

const triggerCertificateSyncAndNotify = createHandlerChainRunner(chain, "TriggerCertificateSyncAndNotify");
export default triggerCertificateSyncAndNotify;
